<div class="filters__sort">
  <app-ph-input
    *ngIf="sortOptions.length > 0"
    [validation]="'base'"
    type="select"
    bindValue="value"
    name="order_by"
    class="projects-sort"
    [searchable]="false"
    [showRequired]="false"
    [clearable]="false"
    [initValue]="sortOptions[0].value"
    [selectArray]="sortOptions"
    [correctForm]="correctForm"
    (phInputChange)="onSortChange()"
    bindLabel="name"
  ></app-ph-input>
</div>
